"use client"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { settingsLinks } from "../utils"

export default function SettingsSidebar() {
  const path = usePathname()

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex w-64 h-[880px] flex-col py-6 px-3 sticky top-14 ">
        <nav className="flex flex-col space-y-1">
          {settingsLinks.map((link) => (
            <Link key={link.url} href={link.url}>
              <Button
                variant={path?.includes(link.url) ? "secondary" : "ghost"}
                className={cn(
                  "rounded-md w-full justify-start px-3 py-2 text-sm font-normal mb-1",
                  path?.includes(link.url)
                    ? "bg-accent text-accent-foreground"
                    : "text-foreground"
                )}
              >
                {link.title}
              </Button>
            </Link>
          ))}
        </nav>
      </aside>

      {/* Mobile Navigation Bar */}
      <nav className="md:hidden w-full bg-background py-2 border-b z-50 overflow-x-auto">
        <div className="px-3 flex space-x-2 min-w-max">
          {settingsLinks.map((link) => (
            <Link key={link.url} href={link.url}>
              <Button
                variant={path?.includes(link.url) ? "secondary" : "ghost"}
                size="sm"
                className="px-3 text-sm whitespace-nowrap"
              >
                {link.title}
              </Button>
            </Link>
          ))}
        </div>
      </nav>
    </>
  )
}
